import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ViewListIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.75684 6C3.75684 5.44772 4.20455 5 4.75684 5H20.7568C21.3091 5 21.7568 5.44772 21.7568 6C21.7568 6.55228 21.3091 7 20.7568 7H4.75684C4.20455 7 3.75684 6.55228 3.75684 6ZM3.75684 10C3.75684 9.44772 4.20455 9 4.75684 9H20.7568C21.3091 9 21.7568 9.44772 21.7568 10C21.7568 10.5523 21.3091 11 20.7568 11H4.75684C4.20455 11 3.75684 10.5523 3.75684 10ZM3.75684 14C3.75684 13.4477 4.20455 13 4.75684 13H20.7568C21.3091 13 21.7568 13.4477 21.7568 14C21.7568 14.5523 21.3091 15 20.7568 15H4.75684C4.20455 15 3.75684 14.5523 3.75684 14ZM3.75684 18C3.75684 17.4477 4.20455 17 4.75684 17H20.7568C21.3091 17 21.7568 17.4477 21.7568 18C21.7568 18.5523 21.3091 19 20.7568 19H4.75684C4.20455 19 3.75684 18.5523 3.75684 18Z"
            />
        </SvgIcon>
    );
};

export default ViewListIcon;
